<template>
  <div class="slide" :id="'slide-' + name" :style="computedStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'slide',
  props: {
    name: {
      type: String,
      required: true,
    },
    zIndex: {
      type: Number,
      default: 0,
    },
    _IS_COMPONENT__SLIDE: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    computedStyle() {
      return {
        zIndex: this.zIndex,
        transform: `translateY(${this.visible ? 0 : 100}%)`,
      };
    },
  },
};
</script>
